import { modules } from "../data/mock";

const STEP_LABEL = { learn: "Learn", talk: "Talk", practice: "Practice", story: "Story", dodont: "Do & Don't", quiz: "Quiz" };
const STEPS = Object.keys(STEP_LABEL);
const lessonName = (id) => { const m = modules.find((x) => x.id === id); return m ? `Lesson ${modules.indexOf(m) + 1}` : id; };
const same = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

// Human-readable list of what differs between the saved payload and the current child.
export const describeChanges = (prev, cur) => {
  const out = [];
  if (!prev) return ["New child - not yet on the server"];
  if (!same(prev.panda, cur.panda)) out.push("Panda edited");
  const prevDay = prev.lesson_day ?? null, curDay = cur.lessonDay ?? null;
  if (prevDay !== curDay) out.push("Lesson day changed");
  const prevGoal = prev.weekly_goal ?? null, curGoal = cur.weeklyGoal ?? null;
  if (prevGoal !== curGoal) out.push("Weekly goal changed");
  const pc = prev.completed || {}, cc = cur.completed || {};
  for (const mid of Object.keys(cc)) {
    const before = pc[mid] || {}, after = cc[mid] || {};
    for (const step of STEPS) {
      const was = before[step] !== undefined && before[step] !== false;
      const is = after[step] !== undefined && after[step] !== false;
      if (is && !was) out.push(`${lessonName(mid)} · ${STEP_LABEL[step]} done`);
      else if (is && was && step === "quiz" && !same(before.quiz, after.quiz)) out.push(`${lessonName(mid)} · Quiz retaken`);
    }
    if (after.certifiedAt && !before.certifiedAt) out.push(`${lessonName(mid)} · Certificate earned`);
  }
  const pw = prev.worksheets || {}, cw = cur.worksheets || {};
  for (const mid of Object.keys(cw)) if (!same(pw[mid], cw[mid])) out.push(`${lessonName(mid)} · Worksheet answers`);
  if (!out.length) out.push("Progress updated");
  return out;
};
